﻿import { VersionedFileEntityType } from '../../enums/index';
import { IDocumentsVersion } from './documents-version';

export interface IVersionedFile {
    id: number;
    entityType: VersionedFileEntityType;
    entityTypeId: number;
    fileType: string;
    fileName: string;
    fileSize: number;
    effectiveDate: string;
    createdDateTime: Date;
    documentsVersionId: number;
    documentsVersion: IDocumentsVersion;
    isStreamlined: boolean;
}
